import AddIcon from '@mui/icons-material/Add';
import { IconButton, useTheme } from '@mui/material';

interface AddButtonProps {
    onAdd: () => void;
}

export const AddButton = ({ onAdd }: AddButtonProps) => {
    const theme = useTheme();
    return (
        <IconButton
            sx={{ alignSelf: 'flex-end', color: theme.palette.customColors.purple }}
            onClick={onAdd}
        >
            <AddIcon />
        </IconButton>
    );
};
